'use client'

import type { ReactNode } from 'react'
import Link from 'next/link'
import { cn } from '@/lib/utils'
import { Button } from './button'

type ImmediateUseButtonProps = {
  href: string
  icon: ReactNode
  traceEvent?: { event: string; data?: Record<string, unknown> }
  label?: string
  className?: string
}

export function ImmediateUseButton({ href, icon, traceEvent, label = '立即使用', className }: ImmediateUseButtonProps) {
  return (
    <Button
      as={Link}
      href={href}
      variant="none"
      traceEvent={traceEvent}
      className={cn(
        'group relative flex h-[79px] w-[270px] items-center justify-center overflow-hidden rounded-[63px] border border-white px-8 text-[28px] font-medium text-white transition duration-300 hover:-translate-y-0.5',
        className
      )}
    >
      {/* 默认态保持现有紫色底，hover 时通过渐变遮罩淡入到用户指定的蓝绿效果。 */}
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 rounded-[inherit] bg-[#685EF6]"
        style={{
          boxShadow: '-6px -7px 23.7px 0 rgba(159, 69, 255, 0.63) inset, 6px 6px 5.9px 0 rgba(30, 20, 184, 0.86) inset'
        }}
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 rounded-[inherit] opacity-0 transition duration-300 group-hover:opacity-100"
        style={{
          backgroundImage: 'linear-gradient(110deg, #2f46ff 0%, #2b78ff 48%, #46fec3 100%)',
          boxShadow: '-6px -7px 23.7px 0 rgba(72, 253, 196, 0.3) inset, 6px 6px 5.9px 0 rgba(30, 20, 184, 0.86) inset'
        }}
      />
      <span className="relative z-10 flex items-center gap-3">
        {icon}
        <span>{label}</span>
      </span>
    </Button>
  )
}
